import { AdminDashboardDataFilter, AdminDashboardReservationsDataResponse } from '../../graphql/API';
import { adminGetDashboardReservationsData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardReservationsDataApi = async (
  filter: AdminDashboardDataFilter,
): Promise<AdminDashboardReservationsDataResponse> => {
  const result = await executeGql(adminGetDashboardReservationsData, { filter });
  return processGqlResult<AdminDashboardReservationsDataResponse>(
    'adminGetDashboardReservationsData',
    result,
  );
};
